import React from "react";
import "./Footer.css";
import footer_logo from "../Assets/logo.webp";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-logo">
        <img src={footer_logo} alt="" />
        <p>FASHION SPICE</p>
      </div>

      <div className="footer-copyright">
        <hr />

        <div className="copyright-content">
          <p>Copyright © 2025</p>
          <p className="developer-credits">
            Developed & Maintained by :
            <span
              className="enver-link"
              onClick={() =>
                window.open(
                  "https://www.enveraitech.com",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Enver AITech
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
